
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import Table from "@/components/base/table/body/TableMedia.vue";
import RadioHeader from "@/components/base/table/header/RadioHeader.vue";
import { Action, Getter, State } from "vuex-class";
import { getImage } from "@/api/common";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import Marquee from "@/components/semantics/Marquee.vue";
import { deepClone, getParentArea } from "@/common/utils";
import config from "@/config";
import { getToolsPageList } from "@/api/policyTools";
@Component({
  name: "Media",
  components: {
    RadioHeader,
    Table,
    Marquee,
    Pagination,
  },
})
export default class Media extends Vue {
  @State("directCityList") private directCityList: any;
  @Getter("cityId") private cityId: any;
  @Getter("city") private city: any;
  @Action("policy/getPublicyList") private getPublicyList: any;
  area_option: any = [];
  tableData: any = [];
  btnList: any = [
    {
      label: "视频解读",
      value: "视频解读",
    },
    {
      label: "文字解读",
      value: "文字解读",
    },
    {
      label: "图片解读",
      value: "图片解读",
    },
  ];
  active: any = 0;
  current4: any = 1;
  pages4: any = 0;
  total4: any = 0;
  size4: any = 15;
  current_option: any = {};
  created() {
    this.getData();
  }
  loading: boolean = false;
  clickMarquee(options: any) {
    console.log(options, "options");
    options.addressCode ? options.addressCode : this.city.id;
    this.current_option = {
      addressCode: options.addressCode,
      departmentId: options.departmentId,
      nature: options.nature,
    };
    this.getData(1);
  }
  getData(type = 0) {
    this.loading = true;
    let options: any = {
      pageNumber: this.current4,
      pageSize: this.size4,
    };

    getToolsPageList(options)
      .then((res: any) => {
        let { code, result } = res.data;
        if (code === 200) {
          let imageList = [
            require("@images/icon/tool_service_0.png"),
            require("@images/icon/tool_service_1.png"),
            require("@images/icon/tool_service_2.png"),
            require("@images/icon/tool_service_3.png"),
            require("@images/icon/tool_service_4.png"),
            require("@images/icon/tool_service_5.png"),
          ];
          const { total, list, pages } = result;
          list.map((item: any, index: number) => {
            this.tableData.push({
              title: item.name,
              id: item.id,
              withPicturesUrl: imageList[index % 6],
              path: "/pcm/verify",
            });
          });
          this.total4 = total;
          this.pages4 = pages;
        }
      })
      .finally(() => (this.loading = false));
  }
  handleClickBtn(index: any) {
    this.active = index;
    this.current4 = 1;
    this.getData(0);
  }
  toDetail({ path, id, title }: any) {
    this.$router.push({
      path: path,
      query: { policyId: id, name: title },
    });
  }

  currentChange4(params: any) {
    this.current4 = params;
    this.getData(1);
  }
}
